export const teamTranslations = {
  TEAM_TITLE: 'Our Team',
  TEAM_SUBTITLE: 'Meet the Tranzer team!',
};
